let googleLoadPromise = null;
let loadedKey = null;

/**
 * Lazily load the Google Maps JavaScript SDK (with Places library).
 * Safe to call multiple times — the script is injected only once.
 */
const loadGoogleMaps = (apiKey) => {
  if (window.google?.maps?.places) return Promise.resolve();
  if (!apiKey) return Promise.reject(new Error('No API key'));
  if (loadedKey !== apiKey) {
    googleLoadPromise = null;
    loadedKey = apiKey;
  }
  if (googleLoadPromise) return googleLoadPromise;
  googleLoadPromise = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    s.async = true;
    s.onload = resolve;
    s.onerror = reject;
    document.head.appendChild(s);
  });
  return googleLoadPromise;
};

export default loadGoogleMaps;
